export default "__VITE_ASSET__DPxwBd48__"